export default "__VITE_ASSET__e1y$yAnM__"